import axios from "axios";
import session from "../session";

export default class AxiosManager {

    constructor(tokenCookieKey) {
        this._tokenCookieKey = tokenCookieKey;
    }

     get (url, data) {
        let res= this.axios_get(url,data);

        return res;
    }

     post_json (url, data,postAuth) {
        let contentType="application/json; charset=utf-8";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        let res= this.axios_post(url,formData,contentType,postAuth);

        return res;
    }

     post_form (url, data) {
        let contentType="application/json; charset=utf-8";

        let res= this.axios_post(url,data,contentType);

        return res;
    }

     post_file (url,file, data) {
        // let contentType="";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        formData.append("file", file);

        let res= this.axios_post(url,formData);

        return res;
    }

     post_files (url,files, data) {
        // let contentType="application/x-www-form-urlencoded; charset=utf-8";
        let contentType="multipart/form-data";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        for (let file of files) {
            formData.append('files', file);
        }
        // formData.append("files", files);

        let res= this.axios_post(url,formData,contentType);

        return res;
    }

    axios_get (url, data) {
        return new Promise((resolve,reject) => {
            axios.defaults.adapter = require('axios/lib/adapters/http')
            axios.defaults.withCredentials=true

            let axiosConfig={
                headers: {
                    withCredentials: true,
                },
            };

            let token=session.getTokenByKey(this._tokenCookieKey)
            if (token){
                axiosConfig.headers.Authorization="Bearer " +token
            }

            axiosConfig.headers.CC=process.env.VUE_APP_publicPath
            axiosConfig.headers.ST=process.env.VUE_APP_siteType
            axiosConfig.headers.HH=location.host

            axios.get(url, {params: data,axiosConfig})
                .then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                reject(err)
            })
        })
    }

    axios_post (url, formData,contentType,postAuth) {
        return new Promise((resolve,reject) => {
            let axiosConfig = undefined;

            axiosConfig={
                headers: {
                    'Content-Type': contentType,
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
                    "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization",
                    // 'Authorization': "Bearer " + session.getToken(),
                },
            };

            // let token=session.getTokenByKey(this._tokenCookieKey)
            let token=localStorage.getItem("api_token");
            if (token){
                if (postAuth ===undefined ){
                    axiosConfig.headers.Authorization="Bearer " +token      //一般用
                    // axiosConfig.headers['X-Token']=token        //asp.net core用
                }else{
                    if (postAuth){
                        //login時，不要帶jwt
                        axiosConfig.headers.Authorization="Bearer " +token//一般用
                        // axiosConfig.headers['X-Token']=token        //asp.net core用
                    }
                }
            }

            axiosConfig.headers.CC=process.env.VUE_APP_publicPath
            axiosConfig.headers.ST=process.env.VUE_APP_siteType
            axiosConfig.headers.HH=location.host

            axios.defaults.adapter = require('axios/lib/adapters/http')
            axios.defaults.withCredentials=true

            axios.post(url, formData,axiosConfig)
                .then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                reject(err)
            })
        })
    }
}

